export default values => {
  return {
    currentKamId: values.id,
    newKamId: ''
  };
};
